import React, { useState, useEffect } from 'react';
import useData from '../../hooks/useData';
import { DROPDOWN_CATEGORY } from '../../config/config';
import { useIsMobile900 } from '../../hooks/mobile';
import Select, { components } from "react-select";
import styles from "./growth.module.scss";
import GrowthDetail from '../common/growthDetail/GrowthDetail';
import { groupBy } from '../../hooks/utils';

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {!props.selectProps.menuIsOpen && (
          <svg
            aria-hidden="true"
            focusable="false"
            className={styles.chevronDown}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"
            ></path>
          </svg>
        )}
        {props.selectProps.menuIsOpen && (
          <svg
            aria-hidden="true"
            focusable="false"
            role="img"
            className={styles.chevronUp}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z"
            ></path>
          </svg>
        )}
      </components.DropdownIndicator>
    )
  );
};

const compareDropDownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        {!props.selectProps.menuIsOpen && (
          <svg width="19px" height="11px" viewBox="0 0 19 11" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g transform="translate(-192.000000, -40.000000)" stroke="currentColor" strokeWidth="3">
                      <g transform="translate(16.000000, 26.000000)">
                          <g transform="translate(177.403619, 15.000000)">
                              <polyline points="0 0 7.86277262 7.86277262 15.7255452 0"></polyline>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
        )}
        {props.selectProps.menuIsOpen && (
          
          <svg width="19px" height="11px" viewBox="0 0 19 11" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g transform="translate(-192.000000, -39.000000)" stroke="currentColor" strokeWidth="3">
                      <g transform="translate(16.000000, 26.000000)">
                          <g transform="translate(177.403619, 15.000000)">
                              <g transform="translate(8.000000, 4.000000) rotate(-180.000000) translate(-8.000000, -4.000000) ">
                                  <polyline points="0 0 7.86277262 7.86277262 15.7255452 0"></polyline>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
        )}
      </components.DropdownIndicator>
    )
  );
};

const GrowthGraph = () =>{

    const {privateWealthData} = useData();
    const isMobile = useIsMobile900();
    const options = DROPDOWN_CATEGORY;
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedValue, setSelectedValue] = useState({value:options[0], label:options[0]});
    const [radioboxSelected, setRadioboxSelected] = useState('HNWIGrowthForecast');
    const [compareCountryOptions, setCompareCountryOptions] = useState();
    const [compareCountrySelected, setCompareCountrySelected] = useState();
    const [compareData, setCompareData] = useState([]);
    const [showId, setShowId] = useState();
    
    const selectStyles = {
      menu: (provided) => ({
        ...provided,
        zIndex: 100,
      }),
      control: (provided) => ({
        ...provided,
        background: "#405363",
        border: "none",
        boxShadow: "none",
        borderRadius: 0,
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        background: "#fff",
        color: "#405363",
        padding: isMobile ? 12: 14,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: "#fff",
        fontFamily: "Garamond Regular",
        fontSize: isMobile ? 17 : 26,
        paddingLeft: 6,
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#fff",
        fontFamily: "Garamond Regular",
        fontSize: isMobile ? 17: 26,
        paddingLeft: 6,
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "10px 0",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        background: "#f7f7f7",
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
          ? "#C1C5C8"
          : state.isSelected
          ? "#405363"
          : null,
        color: state.isFocused
          ? "#405363"
          : state.isSelected
          ? "#fff"
          : "#405363",
      }),
    };

    const compareSelectStyles = {
      menu: (provided) => ({
        ...provided,
        zIndex: 100,
        backgroundColor:'#fff',
        borderRadius: 0,
        paddingLeft: 10,
        paddingRight: 10
      }),
      control: (provided) => ({
        ...provided,
        background: "transparent",
        border: "none",
        boxShadow: "none",
        borderRadius: 0,
        color: "#405363",
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: "#405363",
        padding: isMobile ? 14 : 12,
      }),
      placeholder: (provided) => ({
        ...provided,
        color: "#405363",
        fontFamily: "Garamond Regular",
        fontSize: isMobile ? 17: 26,
        paddingLeft: 0,
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        display: "none",
      }),
      singleValue: (provided) => ({
        ...provided,
        color: "#405363",
        fontFamily: "Garamond Regular",
        fontSize: isMobile ? 17 : 26,
        paddingLeft: 0,
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: "10px 0",
      }),
      indicatorsContainer: (provided) => ({
        ...provided,
        background: "#f7f7f7",
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: isMobile ? 14 : 18,
        backgroundColor: state.isFocused
          ? "#C1C5C8"
          : state.isSelected
          ? "#405363"
          : null,
        color: state.isFocused
          ? "#405363"
          : state.isSelected
          ? "#fff"
          : "#405363",
      }),
      groupHeading: (provided) => ({
        ...provided,
        background: "#fff",
        fontSize: isMobile ? 17 : 26,
        color: '#405363',
        textTransform :'initial',
        fontFamily: "Garamond Regular",
      }),
      group: (provided) => ({
        ...provided,
        borderBottom:"1px solid #C1C5C8"
      }),
    };

    useEffect(() => {
        if (privateWealthData) {
          
          setData(privateWealthData);
          setFilteredData(privateWealthData.filter(item => item.W10 === true).sort((a, b) => b['HNWIGrowthForecast'] - a['HNWIGrowthForecast']));

          const filterOutW10Data = privateWealthData.filter(item => item.W10 !== true);
          const dataByRegion = Object.entries(groupBy('region')(filterOutW10Data))
                               .map(([key, value]) => ({ 
                                  label: key, 
                                  options: value.map((item, index)=>({value:item.country,label:item.country}))
                               }));
          setCompareCountryOptions(dataByRegion);
        }
    }, [privateWealthData]);

 

    const handleCategorySelect = (option) =>{
      // console.log(option.value);
      setSelectedValue({value:option.value, label: option.label});

      if(option.value === 'W10'){
        setFilteredData(data.filter(item => item.W10 === true).sort((a, b) => b[radioboxSelected] - a[radioboxSelected]));
      }else{
        setFilteredData(data.filter(item => item.region === option.value).sort((a, b) => b[radioboxSelected] - a[radioboxSelected]));
      }
    }

    const handleRadioboxChange = (event) =>{
      setRadioboxSelected(event.target.value);
      setFilteredData(filteredData.sort((a, b) => b[event.target.value] - a[event.target.value]));
    }

    const handleCompareCountrySelect = (option) =>{
      setCompareCountrySelected({value:option.value, label: option.label});
      setCompareData(data.filter(item => item.country === option.value));
      // console.log(data.filter(item => item.country === option.value));
    }

    // handle options group header click event
    // hide and show the options under clicked group
    const handleHeaderClick = (id) => {
      // const node = document.querySelector(`#${id}`).parentElement
      //   .nextElementSibling;
      // const classes = node.classList;
      // if (classes.contains("open")) {
      //   node.classList.remove("open");
      // } else {
      //   node.classList.add("open");
      // }
      setShowId(showId === id ? -1 : id);
    }

    // Create custom GroupHeading component, which will wrap
    // react-select GroupHeading component inside a div and
    // register onClick event on that div
    const CustomGroupHeading = (props) => {

      return (
        <div
          className={`${styles.groupHeadingWrapper} ${showId === props.id ? styles.open : ''}`}
          onClick={() => handleHeaderClick(props.id)}
        >
          <components.GroupHeading {...props} />

          <svg width="11px" height="11px" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g transform="translate(-1.000000, -1.000000)" stroke="currentColor">
                      <g transform="translate(1.250000, 1.000000)">
                          <line x1="5.25" y1="0" x2="5.25" y2="11" className={styles.verticalLine}></line>
                          <line x1="5.25" y1="0" x2="5.25" y2="10.5" transform="translate(5.250000, 5.250000) rotate(-90.000000) translate(-5.250000, -5.250000)"></line>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
      );
    }

    const handleCompareCountrySelectClose = () =>{
      setShowId(-1);
    }

    const handleCompare = (countryName) =>{
       setFilteredData(data.filter(item => item.W10 === true).sort((a, b) => b[radioboxSelected] - a[radioboxSelected]));
       setSelectedValue({value:'W10', label:'W10'});
       setCompareCountrySelected({value:countryName, label: countryName});
       setCompareData(data.filter(item => item.country === countryName));
    }

    return(
        <div className="appContainer">
            <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4 col-lg-3">
                    <h3>Click on the map or the list below to see detailed country information</h3>
                  </div>
                  <div className="col-md-8 col-lg-9">
                    <p>The high-net-worth-individual growth data reflects the percentage change in the number of resident high-net-worth individuals in a country over a certain time frame. Click to view 10-year forecast growth, past year’s growth, or past 10 years’ growth. Select from the dropdown menu to view data for the W10 — the world’s 10 wealthiest countries in 2022 by total wealth (namely, the overall private wealth held by all the individuals living in a country, including all their assets less any liabilities). Add a country to compare its growth with the W10 growth figures. Select a region to view and compare growth data for specific countries and click on a country name to see a detailed breakdown of demographic and wealth population data.</p>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className={styles.controlWrapper}>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={selectedValue}
                        value={selectedValue}
                        options={options.map((d) => {return { value: d, label: d }})}
                        styles={selectStyles}
                        components={{ DropdownIndicator }}
                        onChange={handleCategorySelect}
                      />
                      <div className="custom-radiobox-group mt-4 mb-4" style={{'width': '100%', 'maxWidth': '100%'}}>
                          <label className="custom-radiobox">
                            <input type="radio" value="HNWIGrowthForecast" name="radio" checked={radioboxSelected === 'HNWIGrowthForecast'} onChange={handleRadioboxChange} /> 
                            <span className="label-text">10 YEAR FORECAST<br />(to 2031)</span>
                          </label>
                          <label className="custom-radiobox">
                            <input type="radio" value="HNWIGrowthPastYear" name="radio" checked={radioboxSelected === 'HNWIGrowthPastYear'} onChange={handleRadioboxChange} /> 
                            <span className="label-text">PAST YEAR<br />(2021)</span>
                          </label>
                          <label className="custom-radiobox">
                            <input type="radio" value="HNWIGrowthPast10Years" name="radio" checked={radioboxSelected === 'HNWIGrowthPast10Years'} onChange={handleRadioboxChange} />
                            <span className="label-text">PAST 10 YEARS<br />(2011 to 2021)</span>
                          </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                    <div className="col-12">

                      <table className={styles.table}>
                        <thead>
                          <tr>
                            <th colSpan={4} className="text-right">HNWI Growth % in US Dollar terms</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            filteredData && filteredData.map((item, index)=>
                                <GrowthDetail key={item.country} item={item} radioboxSelected={radioboxSelected} handleCompare={() => handleCompare(item.country)} showCompareButton={item.W10 === false} />
                            )
                          }
                          {
                          selectedValue.value === 'W10' &&
                            <>
                              <tr>
                                <td colSpan={4} style={{padding:'15px'}}>
                                  <p className="mb-0">Add a country for comparison</p>
                                  <div className="row">
                                    <div className="col-md-4 col-lg-3">
                                      <Select
                                        defaultValue={compareCountrySelected}
                                        options={compareCountryOptions}
                                        onChange={handleCompareCountrySelect}
                                        onMenuClose={handleCompareCountrySelectClose}
                                        isSearchable={false}
                                        placeholder="Select country"
                                        components={{ GroupHeading: CustomGroupHeading, DropdownIndicator:compareDropDownIndicator}}
                                        blurInputOnSelect={false}
                                        styles={compareSelectStyles}
                                      />
                                    </div>
                                  </div>
                                 
                                </td>
                              
                              </tr>
                              {compareData.map((item)=>
                                <GrowthDetail key={item.ISO3} item={item} radioboxSelected={radioboxSelected} showCompareButton={false} />
                              )}
                            </>
                          }
                        </tbody>
                      </table> 

                      <p class="mt-3 footer-note">All growth rates are effectively in US dollar terms as HNWIs are defined as individuals with net assets of USD 1 million or more.</p>
                    </div>
                </div>
            </div>
           
        </div>
    );
}

export default GrowthGraph;